export const CHANNEL_GROUP_DIMENSION_SUGGESTIONS = [
  "sessionSource",
  "sessionMedium",
  "sessionSourceMedium",
  "sessionDefaultChannelGrouping",
  "sessionPrimaryChannelGroup",
  "sessionCampaignName",
  "sessionCampaignId",
  "sessionSourcePlatform",
  "sessionManualSource",
  "sessionManualMedium",
  "sessionManualTerm",
  "sessionManualAdContent",
  "sessionGoogleAdsAccountName",
  "sessionGoogleAdsCampaignName",
  "sessionGoogleAdsCampaignId",
  "sessionGoogleAdsAdGroupName",
  "sessionGoogleAdsAdGroupId",
  "source",
  "medium",
  "campaignId",
  "campaignName",
]

const CHANNEL_GROUP_DIMENSION_VALUE_SUGGESTIONS = {
  sessionDefaultChannelGrouping: [
    "Direct",
    "Organic Search",
    "Paid Search",
    "Paid Social",
    "Organic Social",
    "Paid Shopping",
    "Organic Shopping",
    "Display",
    "Paid Video",
    "Organic Video",
    "Cross-network",
    "Email",
    "Referral",
    "Affiliates",
    "Audio",
    "SMS",
    "Push",
    "Unassigned",
    "(Other)",
    "(not set)",
  ],
  sessionPrimaryChannelGroup: [
    "Direct",
    "Organic Search",
    "Paid Search",
    "Paid Social",
    "Organic Social",
    "Paid Shopping",
    "Organic Shopping",
    "Display",
    "Paid Video",
    "Organic Video",
    "Cross-network",
    "Email",
    "Referral",
    "Affiliates",
    "Audio",
    "SMS",
    "Push",
    "Unassigned",
    "(Other)",
    "(not set)",
  ],
  sessionSource: [
    "google",
    "bing",
    "facebook.com",
    "l.facebook.com",
    "instagram.com",
    "linkedin.com",
    "youtube.com",
    "t.co",
    "twitter.com",
    "newsletter",
    "reddit.com",
    "pinterest.com",
    "snapchat.com",
    "tiktok.com",
    "(direct)",
    "(not set)",
  ],
  source: [
    "google",
    "bing",
    "facebook.com",
    "l.facebook.com",
    "instagram.com",
    "linkedin.com",
    "youtube.com",
    "t.co",
    "twitter.com",
    "newsletter",
    "reddit.com",
    "pinterest.com",
    "snapchat.com",
    "tiktok.com",
    "(direct)",
    "(not set)",
  ],
  sessionMedium: [
    "organic",
    "cpc",
    "ppc",
    "paidsearch",
    "paid social",
    "social",
    "display",
    "video",
    "audio",
    "affiliate",
    "referral",
    "email",
    "sms",
    "push",
    "(none)",
    "(not set)",
  ],
  medium: [
    "organic",
    "cpc",
    "ppc",
    "paidsearch",
    "paid social",
    "social",
    "display",
    "video",
    "audio",
    "affiliate",
    "referral",
    "email",
    "sms",
    "push",
    "(none)",
    "(not set)",
  ],
  sessionSourceMedium: [
    "google / organic",
    "google / cpc",
    "bing / cpc",
    "facebook.com / referral",
    "instagram.com / social",
    "linkedin.com / social",
    "youtube.com / video",
    "newsletter / email",
    "(direct) / (none)",
  ],
  sessionCampaignName: [
    "Brand | Search",
    "Brand | Remarketing",
    "Prospecting",
    "Retargeting",
    "Awareness",
    "Newsletter",
    "Seasonal",
    "(not set)",
  ],
  campaignName: [
    "Brand | Search",
    "Brand | Remarketing",
    "Prospecting",
    "Retargeting",
    "Awareness",
    "Newsletter",
    "Seasonal",
    "(not set)",
  ],
  sessionCampaignId: [
    "1234567890",
    "9876543210",
    "1122334455",
    "6677889900",
    "(not set)",
  ],
  campaignId: [
    "1234567890",
    "9876543210",
    "1122334455",
    "6677889900",
    "(not set)",
  ],
  sessionSourcePlatform: [
    "Google Ads",
    "Google Marketing Platform",
    "Manual",
    "Facebook",
    "LinkedIn",
    "Pinterest",
    "Snapchat",
    "TikTok",
    "Bing",
    "Reddit",
  ],
  sessionManualSource: [
    "google",
    "bing",
    "facebook",
    "instagram",
    "linkedin",
    "newsletter",
    "(direct)",
  ],
  sessionManualMedium: [
    "organic",
    "cpc",
    "ppc",
    "email",
    "display",
    "paid social",
    "social",
    "affiliate",
  ],
  sessionManualTerm: [
    "branded",
    "nonbrand",
    "remarketing",
    "retargeting",
    "prospecting",
    "(not set)",
  ],
  sessionManualAdContent: [
    "headline_a",
    "headline_b",
    "creative_1",
    "creative_2",
    "promotion",
    "(not set)",
  ],
  sessionGoogleAdsAccountName: [
    "Brand Account",
    "Performance Max",
    "Ecommerce",
    "Lead Gen",
    "(not set)",
  ],
  sessionGoogleAdsCampaignName: [
    "Brand | Search",
    "Brand | Performance Max",
    "Remarketing | Display",
    "Prospecting | Video",
    "Local | Search",
    "(not set)",
  ],
  sessionGoogleAdsCampaignId: [
    "1234567890",
    "2345678901",
    "3456789012",
    "4567890123",
  ],
  sessionGoogleAdsAdGroupName: [
    "Brand - Exact",
    "Brand - Broad",
    "Remarketing",
    "Competitor",
    "Prospecting",
    "(not set)",
  ],
  sessionGoogleAdsAdGroupId: [
    "123456789012345678",
    "234567890123456789",
    "345678901234567890",
  ],
}

export const CHANNEL_GROUP_GENERIC_VALUE_SUGGESTIONS = [
  "Direct",
  "Organic Search",
  "Paid Search",
  "Paid Social",
  "Organic Social",
  "Display",
  "Video",
  "Audio",
  "Email",
  "Referral",
  "Affiliates",
  "Cross-network",
  "Unassigned",
  "(Other)",
  "(none)",
  "(not set)",
  "google",
  "bing",
  "facebook.com",
  "instagram.com",
  "linkedin.com",
  "cpc",
  "organic",
  "newsletter",
  "retargeting",
]

const NORMALIZED_DIMENSION_LOOKUP = Object.fromEntries(
  Object.entries(CHANNEL_GROUP_DIMENSION_VALUE_SUGGESTIONS).map(
    ([key, values]) => [
      key
        .toLowerCase()
        .replace(/[^a-z0-9]/g, ""),
      values,
    ]
  )
)

export function getChannelGroupingValueSuggestions(fieldName) {
  if (!fieldName || typeof fieldName !== "string") {
    return CHANNEL_GROUP_GENERIC_VALUE_SUGGESTIONS
  }
  if (CHANNEL_GROUP_DIMENSION_VALUE_SUGGESTIONS[fieldName]) {
    return CHANNEL_GROUP_DIMENSION_VALUE_SUGGESTIONS[fieldName]
  }
  const normalized = fieldName.toLowerCase().replace(/[^a-z0-9]/g, "")
  return (
    NORMALIZED_DIMENSION_LOOKUP[normalized] ||
    CHANNEL_GROUP_GENERIC_VALUE_SUGGESTIONS
  )
}
